import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ExternalOffer} from '../../data/models/external-offer.model';
import {DomSanitizer} from '@angular/platform-browser';
import {ImageService} from './image.service';
import {TranslationService} from "./translation.service";
import {ImageHandler} from "../../image-handler.service";
import {catchError} from "rxjs/operators";
import {Observable, throwError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ExternalOfferService {
  externalOffersForSlider: ExternalOffer[] = [];
  externalOffersForGroup: ExternalOffer[] = [];
  baseUrlSlider: string = '/webabo/externalOffer/slider';
  baseUrlOfferGroup: string = '/webabo/externalOffer/offerGroup/';

  constructor(private httpClient: HttpClient,
              private imageService: ImageService,
              private imageHandler: ImageHandler,
              private translationService: TranslationService
  ) {
  }

  loadExternalOffersForSlider(): any {
    return this.httpClient.get<ExternalOffer[]>(this.baseUrlSlider);
  }

  loadExternalOffersForOfferGroup(offerGroupId: string): any {
    return this.httpClient.get<ExternalOffer[]>(this.baseUrlOfferGroup + offerGroupId).subscribe(offers => {
      if (offers) {
        offers.forEach(offer => {
          if (offer.image && offer.image.type && offer.image.file) {
            offer.image = this.imageHandler.handleImage(offer.image, offer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
          }
        });
      }
      catchError(this.handleError)
    });
  }

  getExternalOffersForSlider(): ExternalOffer[] {
    return this.loadExternalOffersForSlider().subscribe(externalOffers => {
      if (externalOffers) {
        this.externalOffersForSlider = externalOffers;
        this.externalOffersForSlider.forEach(externalOffer => {
          this.imageService.getImageOrError(externalOffer.id).subscribe(image => {
            if (image && image.type && image.file) {
              externalOffer.image = this.imageHandler.handleImage(image, externalOffer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
            } else {
              externalOffers.splice(externalOffers.indexOf(externalOffer));
            }
          });
        });
      }
      return this.externalOffersForSlider;
    });
  }

  getExternalOffersForOfferGroup(offerGroupId: string): any {
    this.loadExternalOffersForOfferGroup(offerGroupId).subscribe((externalOffers: ExternalOffer[]) => {
      if (externalOffers) {
        this.externalOffersForGroup = externalOffers;
        this.externalOffersForGroup.forEach(externalOffer => {
          this.imageService.getImageOrError(externalOffer.id).subscribe(image => {
            if (image && image.type && image.file) {
              externalOffer.image = this.imageHandler.handleImage(image, externalOffer.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
            }
          });
        });
      }
    });
    return this.externalOffersForGroup;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.status === 404) {
      errorMessage = 'No ExternalOffers found!';
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => errorMessage);
  }
}
